'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _load$loading$loaded$;

var _Download = require('./Icon/Download');

var _Download2 = _interopRequireDefault(_Download);

var _Offline = require('./Icon/Offline');

var _Offline2 = _interopRequireDefault(_Offline);

var _Warning = require('./Icon/Warning');

var _Warning2 = _interopRequireDefault(_Warning);

var _Loading = require('./Icon/Loading');

var _Loading2 = _interopRequireDefault(_Loading);

var _constants = require('./constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var load = _constants.icons.load,
    loading = _constants.icons.loading,
    loaded = _constants.icons.loaded,
    error = _constants.icons.error,
    noicon = _constants.icons.noicon,
    offline = _constants.icons.offline;
exports.default = (_load$loading$loaded$ = {}, _defineProperty(_load$loading$loaded$, load, _Download2.default), _defineProperty(_load$loading$loaded$, loading, _Loading2.default), _defineProperty(_load$loading$loaded$, loaded, null), _defineProperty(_load$loading$loaded$, error, _Warning2.default), _defineProperty(_load$loading$loaded$, noicon, null), _defineProperty(_load$loading$loaded$, offline, _Offline2.default), _load$loading$loaded$);


// WEBPACK FOOTER //
// ./node_modules/react-ideal-image/dist/components/icons.js